import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { blueprintThemesCss, tokensToCss } from '@il-colpo/shared/design';
import { getAccountStore } from './account/accountStore.ts';
import { trackSettingsStamps } from './account/syncMeta.ts';
import { App } from './app/App.tsx';
import { bindSettingsToApp } from './app/bindSettings.ts';
import { audio } from './audio/manager.ts';
import { startNative } from './native/native.ts';
import { startPwa } from './pwa/pwaStore.ts';
import './styles/fonts.ts';
import './styles/global.css';

// Design tokens come from one place (packages/shared) and become CSS custom properties
// before the first render, so CSS never has a second copy of the palette.
const tokenStyle = document.createElement('style');
tokenStyle.id = 'design-tokens';
tokenStyle.textContent = `${tokensToCss()}
${blueprintThemesCss()}`;
document.head.prepend(tokenStyle);

bindSettingsToApp();
// Cross-save needs to know when each setting last changed, signed in or not; the account service
// itself is loaded only if this page returns to a session (or an account screen asks for it).
trackSettingsStamps();
getAccountStore().getState().init();
// The sound wakes at the first touch of the page, the splash's included.
audio.install();
// The web app: a service worker for the offline game and the updates, and the install offer.
void startPwa();
// A native shell: system bars, back button, the way back from a provider's page, and the splash goes away.
void startNative();

// The handle the end-to-end tests hold on the sound exists in development builds only.
if (import.meta.env.DEV || import.meta.env['VITE_ENABLE_DEBUG'] === 'true')
  void import('./audio/hook.ts');
if (import.meta.env.DEV || import.meta.env['VITE_ENABLE_DEBUG'] === 'true')
  void import('./game/scene/hook.ts');

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
